import React from 'react';
import { useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { findMedia } from '@interness/web-core/src/components/_helpers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const HeaderImg = _ref => {
  let {
    id
  } = _ref;
  const {
    headerImages
  } = useStaticQuery(query);
  return ___EmotionJSX(Img, {
    fluid: findMedia(headerImages.images, id).childImageSharp.fluid
  });
};
export default HeaderImg;
const query = "4206306598";